import React, { useState, useRef } from 'react';
import { useFloating, offset, flip, shift, arrow, useClick, useDismiss, useInteractions } from '@floating-ui/react';
import tooltipIcon from "../../assets/icons/helpTooltipIcon.svg";
import popOverInfoIcon from "../../assets/icons/whiteInfoIcon.svg";
import styles from "./DayPartPopOver.module.css";

interface ReasonPopOverProps {
    title?: string;
    message?: string;
}

const ReasonPopOver: React.FC<ReasonPopOverProps> = ({ title, message }) => {
    const [open, setOpen] = useState(false);

    const arrowRef = useRef<HTMLDivElement | null>(null);

    const {
        x,
        y,
        strategy,
        refs,
        middlewareData,
        context,
    } = useFloating({
        placement: 'bottom-start',
        open,
        onOpenChange: setOpen,
        middleware: [offset(8), flip(), shift(), arrow({ element: arrowRef })],
    });
    // Create interactions (click to open/close + outside press to dismiss)
    const click = useClick(context, {
        // `toggle: true` means each click on the reference toggles the popover
        toggle: true,
        // If you want it to open on the first click, then close on second click, set this to true
    });
    const dismiss = useDismiss(context, {
        outsidePress: true, // close popover on outside click
        ancestorScroll: true,
    });
    const { getReferenceProps, getFloatingProps } = useInteractions([click, dismiss]);
    const referenceProps = getReferenceProps({
        onMouseDown: (e) => {
            // Prevent the default focus behavior
            e.preventDefault();
        },
    });

    const arrowX = middlewareData.arrow?.x ?? 0;
    const arrowY = middlewareData.arrow?.y ?? 0;

    return (
        <div>
            {/* Attach the reference to the button using refs.setReference */}
            <button ref={refs.setReference} {...referenceProps} className={styles.tooltipButton} type="button">
                <img src={tooltipIcon} className={styles.tooltipIcon} />
            </button>

            {open && (
                // Attach the floating ref to the popover div using refs.setFloating
                <div
                    ref={refs.setFloating}
                    {...getFloatingProps()}
                    className={styles.popover}
                    style={{
                        position: strategy,
                        top: y ?? 0,
                        left: x ?? 0,
                        zIndex: 9999,
                    }}
                >
                    <div className={styles.header}>
                        <img src={popOverInfoIcon} className={styles.popOverInfoIcon} />
                        <div className={styles.headerTitle}>
                            {title ?? "Reason"}
                        </div>
                    </div>
                    <div className={styles.content}>
                        {message}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ReasonPopOver;
